const styles = {
  button: {}
}

export default styles
